import React from "react";
import styles from "./icon.module.scss"; // Import css modules stylesheet as styles

export function getIcon(iconName, customStyles = null, onError = null, onClick = null) {
    const additionalClasses = (customStyles !== null) ? customStyles : "";
    var icon = require(`../media/images/icons/line/dark/${iconName}`).default;
    return <img className={styles.icon + " " + additionalClasses} src={icon} onError={onError} onClick={onClick} alt={iconName} />;
}
